import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PaletteKey} from '@/components/ui/text/Text'
import styled from 'styled-components'

export const StyledRenewedTooltipContent = styled(Flexbox)<{paletteKey: PaletteKey}>(
    ({paletteKey, theme: {palette}}) => ({
        color: palette[paletteKey]['500']
    })
)
